import React, { useEffect, useState } from "react";

import { useGalleryContext } from "../../Contexts/GalleryContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PreviewMedia from "./PreviewMediaDialog";

import { useDispatch, useSelector } from 'react-redux';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import PlaylistMediaPreview from "../DragDrop/components/PlaylistMediaPreview";

/**
 * Pass `mountPreview={false}` from callers that mount the preview
 * dialog themselves (e.g. MediaGallery / LinksGallery, which render
 * one shared <PreviewMediaDialog/> for every item so audio files
 * — which don't render a thumbnail through LazyImage — can also open
 * the preview). In that mode LazyImage also drops its onClick so the
 * parent's handler isn't double-fired into a toggle-cancel.
 */
const LazyImage = ({ media, popupType, styleClass = "", mountPreview = true }) => {
  const dispatch = useDispatch();
  const openDialog = useSelector((state) => state.global.openDialog);
  const { selectedItem, setSelectedItem } = useGalleryContext();
  const [thumb, setThumb] = useState();

  const selectDialog = !mountPreview ? undefined : () => {
    if (popupType == "media_preview") {
      setSelectedItem(media.id)
      dispatch(toggleDialog("previewMedia"));
    } else if (popupType == "playlistMediaPreview") {
      setSelectedItem(media.id)
      dispatch(toggleDialog("playlistMediaPreview"));
    } else {
      dispatch(toggleDialog("mediaSettingPopup"))
    }
  };

  useEffect(() => {
    let oldUrl = "http://storage-popuppush-copy.s3.eu-west-1.amazonaws.com";
    let oldUrl2 = "http://storage-popuppush.s3.me-south-1.amazonaws.com";
    let newUrl = "https://storage.popuppush.com";

    if (media?.thumb?.includes(oldUrl))
      setThumb((media?.thumb)?.replace(oldUrl, newUrl))
    else if (media?.thumb?.includes(oldUrl2))
      setThumb((media?.thumb)?.replace(oldUrl2, newUrl))
    else if (media?.thumb === "loading") {
      setThumb("loader")
    }
    else
      setThumb(media?.thumb)
  }, [media])


  return (
    <>
      {thumb === "loader" ?
        <div className="bg-gray-300 w-100 h-100 flex justify-center items-center rounded cursor-progress" style={{ minWidth: "78px" }}>
          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
        </div>
        :
        <LazyLoadImage src={thumb}
          className={styleClass != "" ? `${styleClass} cursor-pointer` : `mb-2 mt-4 item cursor-pointer`}
          alt="item" onClick={selectDialog} />
      }

      {mountPreview && selectedItem == media.id && openDialog.previewMedia && <PreviewMedia data={media} />}
      {mountPreview && selectedItem == media.id && openDialog.playlistMediaPreview && <PlaylistMediaPreview item={media} />}

    </>
  );
};

export default LazyImage;
